import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';

import { LoginService } from '../services/login-service/login.service';
import { RequestAccessDataService } from '../../modules/request-access/services/request-access-data.service';
import { ROUTER_CONSTANTS } from '../constants/router.constants';

/**
 * Guards the request-access route:
 * - Redirects logged-in users to the dashboard.
 * - Redirects to the login page if no user data is stored
 *   (e.g. the user navigated directly to /request-access without going
 *   through Auth0 first).
 * @returns boolean or UrlTree redirect
 */
export const RequestAccessGuard: CanMatchFn = (): boolean | UrlTree => {
  const loginService = inject(LoginService);
  const requestAccessDataService = inject(RequestAccessDataService);
  const router = inject(Router);

  if (loginService.isLoggedIn) {
    return router.createUrlTree([ROUTER_CONSTANTS.dashboard]);
  }

  if (!requestAccessDataService.hasUserData()) {
    return router.createUrlTree([ROUTER_CONSTANTS.login]);
  }

  return true;
};
